/**
 * REDUX STORE - Configuração Central
 * 
 * Store principal do Redux Toolkit
 * - ValuationSlice (gerenciamento de estado do DCF)
 */

import { configureStore } from '@reduxjs/toolkit';
import valuationReducer from './slices/valuationSlice';

export const store = configureStore({
  reducer: {
    valuation: valuationReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignorar ações que contêm Date objects
        ignoredActions: ['valuation/setSnapshot', 'valuation/updateScenario'],
        // Ignorar paths no state que contêm Date
        ignoredPaths: ['valuation.snapshot.timestamp']
      }
    })
});

// ============================================================================
// TYPES
// ============================================================================

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
